import { render, staticRenderFns } from "./shortYoutube.vue?vue&type=template&id=fe2cce20"
import script from "./shortYoutube.vue?vue&type=script&lang=js"
export * from "./shortYoutube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe2cce20')) {
      api.createRecord('fe2cce20', component.options)
    } else {
      api.reload('fe2cce20', component.options)
    }
    module.hot.accept("./shortYoutube.vue?vue&type=template&id=fe2cce20", function () {
      api.rerender('fe2cce20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/shortYoutube.vue"
export default component.exports